(() => {
  "use strict"; function e() {
    function e() {
      let e = document.createElement("style"); e.textContent = `
            @media screen and (max-width: 768px) {
                #app-embed div[data-testid="image"] { 
                    display:none;
                }

                #app-embed ._grid_stahb_148._left_stahb_195 {
                    display:block;
                }

                ._grid_1q1d2_148._left_1q1d2_195 {
                  grid-template: 1fr / 1fr !important;
                }

                ._grid_1q1d2_148._left_1q1d2_195 ._formContainerCloseButtonPosition_1q1d2_282 {
                  right: calc(var(--forms-padding-right) - 25px);
                }

                #app-embed {
                  z-index: 900002!important;
                }

                ._grid_1q1d2_148._left_1q1d2_195 ._gridItem_1q1d2_172:nth-child(1){
                    background-image: none!important;
                }
            }
        `; let t = document.querySelector("#app-embed-container-132089"); return !!t && !!t.shadowRoot && (t.shadowRoot.append(e), !0)
    } if (!e()) { let t = new MutationObserver((t, d) => { for (let n of t) if ("childList" === n.type) { let i = document.querySelector("#app-embed-container-132089"); if (i) { d.disconnect(), e(); break } } }); t.observe(document.body, { childList: !0, subtree: !0 }) }
  } function t() { let t = location.pathname; t.includes("/products"), t.includes("/collections"), e() } "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", t, { once: !0 }) : t()
})();